import { Component, Injector, OnInit, HostListener, Input, ElementRef } from '@angular/core';
import { ProfileService, IProfile } from '../../services/profile.service';
import { ActionSheetController, ModalController, NavParams } from '@ionic/angular';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { ProfilePhoneEditModalComponent } from '../../modals/profile-phone-edit-modal/profile-phone-edit-modal.component';
import { AddressEditorModalComponent } from 'src/app/shared/components/address-editor-modal/address-editor-modal.component';
import { Router } from '@angular/router';
import { SupportService } from 'src/app/support/services/support.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NotificationServiceService, INotifications } from 'src/app/store/services/notification-service.service';
import { NotificationBellServiceService } from 'src/app/store/services/notification-bell-service.service';
import { environment } from 'src/environments/environment';
import { ModalDisplayComponent } from 'src/app/shared/components/modal-display/modal-display.component';
import { AccountService, IApiAccount } from '../../services/account.service';
import { AddExistingCardModalComponent } from '../../modals/add-existing-card-modal/add-existing-card-modal.component';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { IconService } from 'src/app/shared/services/icon.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TranslationService } from 'src/app/shared/services/translation.service';

export interface IAddress {
  Province?: string;
  City?: string;
  PostalCode?: string;
  Country?: string;
  Street?: string;
  StreetDirection?: string;
  StreetType?: string;
  Suffix?: string;
  SuiteNumber?: string;
  StreetNumber?: string;
}

export interface IStreet {
  ProvinceCode?: string;
  StreetTypeCode?: string;
  StreetDirectionCode?: string;
  City?: string;
  StreetName?: string;
}

@Component({
    selector: 'app-profile-page',
    templateUrl: './profile-page.component.html',
    styleUrls: ['./profile-page.component.scss'],
    standalone: false
})
export class ProfilePageComponent implements OnInit {

  @Input() profileView: boolean = true;

  seeProfile: boolean = true;
  disableHeader: boolean = false;

  //////////////////////////////////
  // this is the data from the account
  accounts: IApiAccount[];
  primary: IApiAccount;
  reached: boolean = true;
  canGenerateVirtualCard: boolean = false;
  //////////////////////////////////
  

  title: string = 'Nav.Profile';
  memberProfile: IProfile;

  gender: string;
  dateOfBirth: string;
  sendEmail: boolean;
  useGeolocation: boolean;
  phoneNumber: string = '';

  dateOfBirthMaxDate: string;

  valideNotification: number;
  AllNotifications: INotifications[];

  isApp: boolean = environment.deviceApp;

  isPopup: boolean = false;
  mobile: boolean = false;

  bellIcon: IconDefinition;

  ApiAccountResponse: boolean = false;
  ApiPrimaryResponse: boolean = false;


  getCurrentPath(): string {
    return this.router.url;
  }

  constructor(private profile: ProfileService,
    private loader: LoaderService,
    private modalCtrl: ModalController,
    private router: Router,
    //public translate: TranslateService,
    private supportService: SupportService,
    public setting: SettingService,
    private alert: AlertService,
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    private account: AccountService,
    private actionSheetCtrl: ActionSheetController,
    private injector: Injector,
    private analytics: AnalyticsService,
    private iconService: IconService,
    public translationService: TranslationService,
    private element: ElementRef
  ) {
    this.bellIcon = this.iconService.getIcon('bell')!;
  }

  public async ngOnInit() {
    const hostElement = this.element.nativeElement;
    if(this.setting.configuration.uIoptions) {
      hostElement.style.setProperty('--tabs-section', this.setting.configuration.uIoptions?.profileSectionBarColor);
      hostElement.style.setProperty('--tabs-section-txt', this.setting.configuration.uIoptions?.profileTextSectionBarColor);
    }
    
    // only happend in certain cases but still needed
    const value = this.router.getCurrentNavigation()?.extras?.state?.['profileView'];
    if(value != null) {
      this.profileView = value;
    }

    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);

    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
        
      }
    } catch (e) {

    }

    if(!this.isPopup) {
      var currentUrl = this.getCurrentPath();
      localStorage.setItem('Stateurl', currentUrl);
    } else {
      localStorage.setItem('Stateurl', 'popup-profile');
    }
    
    
    this.analytics.UpdateLocation({url: "/account/profile", ispopup: this.isPopup},  true, false);
    
    

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }

    let date = new Date();
    date.setFullYear(date.getFullYear() - 14);
    this.dateOfBirthMaxDate = date.toISOString();

    this.getProfile();


    /////////////////////////////////////////
    // init the account data
    this.reachedLimit();
    this.canGenerateVirtual();
    await this.getPrimary();
    await this.getAccounts();

    ///////////////////////////////////////

    if (window.innerWidth <= 500) {
      this.mobile = true;

      if(this.setting.configuration.uIoptions?.profileToPopup) {
        this.disableHeader = false;
      }
    } else {
      this.mobile = false;

      if(this.setting.configuration.uIoptions?.profileToPopup) {
        this.disableHeader = true;
      }
    }


 
    this.changeProfileView(this.profileView);
    
    //////////////////////////////////////////////////
    // automatically generates a card if you have none on your account
    const interval = setInterval(() => {
      if(this.ApiAccountResponse && this.ApiPrimaryResponse) {
        if (this.accounts.length < 1 && !this.primary) {
          clearInterval(interval);
          this.GenerateCard();
        } else if(this.accounts.length > 0 || this.primary) {
          clearInterval(interval);
        }
      } 
    }, 1000);

    // automatically set the card if only has 1 to primary
    const interval2 = setInterval(() => {
      if(this.ApiAccountResponse && this.ApiPrimaryResponse) {
        if(this.accounts.length == 1 && !this.primary) {
          clearInterval(interval2);
          this.scanCard(this.accounts[0], null, false);
        } else if(this.accounts.length > 1 || this.primary) {
          clearInterval(interval2);
        }
      } 
    }, 1000);
    //////////////////////////////////////////////////

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 500) { // follows the value of the modal
      this.mobile = true;

      if(this.setting.configuration.uIoptions?.profileToPopup) {
        this.disableHeader = false;
      }
    } else {
      this.mobile = false;

      if(this.setting.configuration.uIoptions?.profileToPopup) {
        this.disableHeader = true;
      }
    }
  }

  changeProfileView(profileViewState){
    this.seeProfile = profileViewState;
  }

  getProfile() {
    // get the profile.
    this.profile.getProfile()
      .subscribe((t) => {
        this.setProfile(t)
      },
        () => {

        });
  }

  onManageCreditCardsClicked() {
    this.router.navigate(['account/manage-credit-cards']);
  }

  setProfile(profile: IProfile) {
    this.memberProfile = profile;
    this.gender = profile.Gender;
    this.dateOfBirth = profile.DateOfBirth;

    console.log(this.dateOfBirth);

    if (profile.Phone)
      this.phoneNumber = profile.Phone.trim();

    // page related.
    this.sendEmail = profile.SendEmail;
    this.useGeolocation = profile.UseGeolocation;
  }

  async onPhoneClicked() {
    const modal = await this.modalCtrl.create({
      component: ProfilePhoneEditModalComponent
    });

    modal
      .onDidDismiss()
      .then((result) => {
        if (result.data)
          this.getProfile();
      });

    await modal.present();
  }

  async updateGender() {
    const loader = await this.loader.create();
    this.profile.setGender(this.gender)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(() => {
        this.memberProfile.Gender = this.gender;
      }, () => {
        this.gender = this.memberProfile.Gender;
      });
  }

  async updateSendMail() {
    /// this is needed until ionChange on <ion-toggle> is fixed.
    if (this.memberProfile.SendEmail === this.sendEmail)
      return;

    const loader = await this.loader.create();
    this.profile.setSendMail(this.sendEmail)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(() => {
        this.memberProfile.SendEmail = this.sendEmail;
      }, () => {
        this.sendEmail = this.memberProfile.SendEmail;
      });
  }

  async updateUseGeolocation() {
    /// this is needed until ionChange on <ion-toggle> is fixed.
    if (this.memberProfile.UseGeolocation === this.useGeolocation)
      return;

    const loader = await this.loader.create();
    this.profile.setUseGeolocation(this.useGeolocation)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(() => {
        this.memberProfile.UseGeolocation = this.useGeolocation;
      }, () => {
        this.useGeolocation = this.memberProfile.UseGeolocation;
      });
  }

  async updateDateOfBirth() {
    const loader = await this.loader.create();
    this.profile.setDateOfBirth(this.dateOfBirth)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(() => {
        this.memberProfile.DateOfBirth = this.dateOfBirth;
      }, () => {
        this.dateOfBirth = this.memberProfile.DateOfBirth;
      });
  }

  async beginChangeAddress() {
    const modal = await this.modalCtrl.create({
      component: AddressEditorModalComponent,
      componentProps: {
        skipProvinceValidation: true
      }
    });

    modal
      .onDidDismiss()
      .then(async (result) => {
        if (!result.data)
          return;

        const loader = await this.loader.create();
        await loader.present();
        this.profile.setAddress(result.data)
          .pipe(finalize(async () => {
            await loader.dismiss();
          }))
          .subscribe(() => {
            this.getProfile();
          });
      });

    await modal.present();
  }

  disableAccount() {
    if (confirm(this.translationService.translate("Profile.AccountDisableWarning"))) {
      //triger a contact us form
      this.supportService
      .contact({
        email: this.memberProfile.Email,
        fullName: this.memberProfile.FirstName + " " + this.memberProfile.LastName,
        merchantId: this.setting.getMerchantId(),
        message: "This member triggered the process to deactivate his profile.",
        ipAddress: this.setting.ipAddress        
      })
      .pipe(finalize(async () => {
        await this.alert.showTranslate('Profile.AccountDisableProcessed');
      }))
      .subscribe((result) => {
       
      });
    }
  }

  async openNotificationPage() {
      const loader = await this.loader.create();
      await loader.present();
      await this.router.navigate(['/account/notifications']);


      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }
      

      await loader.dismiss();
  }

  async showTerms(event) {
    event.preventDefault()
    //Fetch terms to SMA/Import them when importing the brand and query us
    const loader = await this.loader.create();
    await loader.present();
    this.setting.getSATerms(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Terms",
            content: terms
          }
        });

        await requestModal.present();
      });
  }

  async showPolicies(event) {
    event.preventDefault();
    //Show SHOPACHAT policies
    const loader = await this.loader.create();
    await loader.present();
    this.setting.getSAPolicies(this.translationService.getLanguage())
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async terms => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Policies",
            content: terms
          }
        });

        await requestModal.present();
      });
  }



  //////////////////////////////////////////
  // everything below was previously in account
  getCardImage(card: IApiAccount) {
    if (card.CardImage)
      return card.CardImage;

    return 'assets/imgs/account/card.png';
  }

  async getPrimary() {
    const loader = await this.loader.create();
    await loader.present();
    this.account.getPrimary()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(
        (primary) => {
          this.primary = primary;
          this.ApiPrimaryResponse = true;
        },
        () => {
        });
  }

  async reachedLimit() {
    const loader = await this.loader.create();
    await loader.present();
    this.account.reachedApiAccountLimit()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((reached) => {
        this.reached = reached;
      });
  }

  async canGenerateVirtual() {
    const loader = await this.loader.create();
    await loader.present();
    this.account.canApiAccountGenerateVirtual()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((reached) => {
        this.canGenerateVirtualCard = reached;
      });
  }

  async getAccounts() {
    const loader = await this.loader.create();
    await loader.present();
    this.account.list()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(
        (accounts) => { 
          this.accounts = accounts;

          this.ApiAccountResponse = true;
        },
        () => {
        });
  }

  async onCardClicked(apiAccount: IApiAccount) {
    let title = this.translationService.translate('Account.SetPrimaryCardConfirmation');
    let actionSheet = await this.actionSheetCtrl.create({
      header: title,
      buttons: [
        {
          text: this.translationService.translate('General.Yes'),
          handler: () => {
            this.setPrimaryCard(apiAccount);
          }
        },
        {
          text: this.translationService.translate('General.Cancel'),
          role: 'cancel',
          handler: () => { }
        }
      ]
    });

    await actionSheet.present();
  }

  async scanCard(apiAccount: IApiAccount, e: any, isPrimary: boolean) {
    try {
      e.stopPropagation();
    }catch (e) {

    }
    
    if(isPrimary) {
      this.setPrimaryCard(apiAccount, true);
    } else {
      this.setPrimaryCard(apiAccount, false);
    }
    
  }

  async onAddCardClicked() {
    const modal = await this.modalCtrl.create({
      component: AddExistingCardModalComponent
    });

    modal.onDidDismiss().then((eventDetail) => {
      if (!eventDetail.data) return;

      this.getAccounts();
    });

    await modal.present();
  }

  async setPrimaryCard(model: IApiAccount, isScan: boolean = false) {
    //we have popups, it needs to be able to open popups too

    const loader = await this.loader.create();
    await loader.present();
    this.account.setPrimary(model)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(
        () => {
          if(isScan){
            this.router.navigate(['/account/pay-rewards']);
            this.closePopup();
          }
          this.primary = model;
        }
      );
  }

  async GenerateCard() {
    const loader = await this.loader.create();
    await loader.present();
    this.account.generate()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(
        () => {
          this.getAccounts();
          this.reachedLimit();
        },
        (response: Response) => {
          this.showError()
        }
      );
    return false;
  }

  async onGenerateCardClicked() {
    let title = this.translationService.translate('Account.GenerateVirtualCardConfirmationMessage');
    let actionSheet = await this.actionSheetCtrl.create({
      header: title,
      buttons: [
        {
          text: this.translationService.translate('General.Yes'),
          handler: () => {
            this.GenerateCard();
          }
        },
        {
          text: this.translationService.translate('General.Cancel'),
          role: 'cancel',
          handler: () => { }
        }
      ]
    });

    await actionSheet.present();
  }

  showError() {
    /*if (response.status == 404) {
      this.auth.alertService.showMessage(this.translate.instant('ACCOUNT.COULD_NOT_FIND_CARD_MSG'));
    } else if (response.status === 400) {
      let errorMessage = HttpHelpers.getBadRequestJsonMessage(response);

      if (errorMessage == "Already.Assigned")
        errorMessage = this.translate.instant('ACCOUNT.ALREADY_ASSIGNED_MSG');
      else if (errorMessage == 'VirtualCard.Limit.Exceeded')
        errorMessage = this.translate.instant('ACCOUNT.VC_LIMIT_EXCEEDED_MSG');

      this.auth.alertService.showMessage(errorMessage);
    }*/
  }

  //////////////////////////////////////////

  profilePopup(){
    if(this.setting.configuration.uIoptions){
      return this.setting.configuration.uIoptions?.profileToPopup;
    } else {
      return false;
    }
    
  }
  
  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }

  changePage(page) {
    if(page == "FLAVOR") {
      console.log("flavor page");
    } else if(page == "NUTRI-ALLERGY") {
      console.log("nutrition and allergy page");
    } else if(page == "SETTINGS") {
      console.log("settings page");
    } else if(page == "CARD") {
      console.log("card page");
    } else if(page == "ORDER-HISTORIC") {
      console.log("order historic page");
    }
  }
}
